import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatabaseComponent } from './database.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [DatabaseComponent]
})
export class DatabaseModule { }



// WEBPACK FOOTER //
// /workspace/chess.arska.org/chess/src/app/database/database.module.ts